import { ProfilePageWizy } from "@/pages/profile/ProfilePageWizy.tsx";
import { isPlatform, platformMostAI } from "@/domains.ts";
import {ProfilePageMostAI} from "@/pages/profile/ProfilePageMostAI.tsx";

export const ProfilePageSwitcher = () => {
  if (isPlatform(platformMostAI)) {
    return <ProfilePageMostAI />;
  }

  return <ProfilePageWizy />;
};
